import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Auth
import { AuthProvider } from "./contexts/AuthContext";

// Components
import { Header } from "./components/Header";
import { ProtectedRoute } from "./components/ProtectedRoute";

// Public Pages
import { Home } from "./pages/public/Home";
import { Projects } from "./pages/public/Projects";
import { About } from "./pages/public/About";
import { ProjectDetail } from "./pages/public/ProjectDetail";
import { ArtworkPage } from "./pages/public/ArtworkPage";
import { ArtworkDetailPage } from "./pages/public/ArtworkDetailPage";

// Admin Pages
import { AdminLogin } from "./pages/admin/AdminLogin";
import { AdminLayout } from "./pages/admin/AdminLayout";
import { AddProjectPage } from "./pages/admin/AddProjectPage";
import { AddArtworkPage } from "./pages/admin/AddArtworkPage";
import { DashboardPage } from "./pages/admin/DashboardPage";
import { ProjectsListPage } from "./pages/admin/ProjectsListPage";
import { EditProjectPage } from "./pages/admin/EditProjectPage";
import { ArtworksListPage } from "./pages/admin/ArtworksListPage";
import { EditArtworkPage } from "./pages/admin/EditArtworkPage";
import { EditSettingsPage } from "./pages/admin/EditSettingsPage";

function App() {
  return (
    <Router>
      <AuthProvider>
        <Header />
        <Routes>
          {/* === Public Routes === */}
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/:id" element={<ProjectDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/artworks" element={<ArtworkPage />} />
          <Route path="/artworks/:id" element={<ArtworkDetailPage />} />

          {/* === Admin Public Route === */}
          <Route path="/admin/login" element={<AdminLogin />} />

          {/* === Protected Admin Routes === */}
          <Route element={<ProtectedRoute />}>
            <Route element={<AdminLayout />}>
              <Route path="/admin" index element={<DashboardPage />} />
              <Route path="/admin/projects/new" element={<AddProjectPage />} />
              <Route path="/admin/projects" element={<ProjectsListPage />} />
              <Route
                path="/admin/projects/edit/:id"
                element={<EditProjectPage />}
              />

              <Route path="/admin/artworks/new" element={<AddArtworkPage />} />
              <Route path="/admin/artworks" element={<ArtworksListPage />} />
              <Route path="/admin/artworks/edit/:id" element={<EditArtworkPage />} />
              <Route path="/admin/settings" element={<EditSettingsPage />} />
            </Route>
          </Route>

          {/* Optional: 404 fallback */}
          <Route path="*" element={<div>Page Not Found</div>} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
